import { render, staticRenderFns } from "./Global-Block.vue?vue&type=template&id=29767a7f&"
import script from "./Global-Block.vue?vue&type=script&lang=js&"
export * from "./Global-Block.vue?vue&type=script&lang=js&"
import style0 from "./Global-Block.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports